import React, { useEffect, useState, useContext } from "react";
import OwnerLayout from "../../../layout/OwnerLayout";
import { FiPlus } from "react-icons/fi";
import { GoPencil } from "react-icons/go";
import { BsTrash3 } from "react-icons/bs";
import { UserContext } from "../../../../context/UserContext";
import { Link } from "react-router-dom";
import {
  deleteRestaurants,
  getRestaurantsByOwner,
} from "../../../../api/restaurants.api";
import { getCurrentUser } from "../../../../api/user.api";
import {
  confirmRestaurantDelete,
  success,
} from "../../../../utils/notifications";

function Restaurants() {
  const [restaurantsData, setRestaurantsData] = useState([]);
  const [ownerProfileExists, setOwnerProfileExists] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(UserContext);

  const fetchRestaurants = () => {
    setLoading(true); // 👈 start loading
    getCurrentUser()
      .then((res) => {
        if (res?.data?.user?.ownerId) {
          setOwnerProfileExists(true);
          return getRestaurantsByOwner(res.data.user.ownerId);
        } else {
          setOwnerProfileExists(false);
          return Promise.resolve({ data: { restaurants: [] } });
        }
      })
      .then((res) => {
        setRestaurantsData(res?.data?.restaurants || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRestaurants();
  }, []);

  const handleDelete = (id) => {
    confirmRestaurantDelete().then(async (result) => {
      if (result.isConfirmed) {
        await deleteRestaurants(id);
        setRestaurantsData(
          restaurantsData.filter((restaurant) => restaurant._id !== id)
        );
        await success("Success!", "Fixed Location deleted successfully!");
      }
    });
  };

  if (loading) {
    return (
      <OwnerLayout title="Fixed Location Management" ownerDetails={user}>
        <div className="px-1 sm:px-3 lg:px-8">
          <div className="text-center">Loading...</div>
        </div>
      </OwnerLayout>
    );
  }

  if (!ownerProfileExists) {
    return (
      <OwnerLayout title="Fixed Location Management" ownerDetails={user}>
        <div className="px-1 sm:px-3 lg:px-8 mt-10">
          <div className="text-center font-bold text-red-600 text-xl my-4">
            Please create Owner profile first.
          </div>
          <div className="text-center">
            <Link
              to="/ownerprofile"
              className="inline-flex items-center justify-center rounded-md bg-yellow px-4 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              Create Owner Profile
            </Link>
          </div>
        </div>
      </OwnerLayout>
    );
  }

  return (
    <OwnerLayout title="Fixed Location Management " ownerDetails={user}>
      <div className="px-1 sm:px-3 lg:px-8">
        <div className="mb-5 flex items-center justify-end sticky top-16 py-3 z-10 px-2">
          <Link
            to="/fixedLocations/add"
            className="flex items-center justify-center rounded-md bg-yellow px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90"
          >
            <FiPlus className="text-lg text-gray-700" />
            <span className="ml-2">Add Fixed Location</span>
          </Link>
        </div>

        <div className="mt-5">
          {loading ? ( // 👈 Show loading message
            <div className="text-center font-bold text-gray-500 text-xl my-4">
              Loading...
            </div>
          ) : restaurantsData.length === 0 ? (
            <div className="text-center font-bold text-gray-600 text-xl my-4">
              No Fixed Locations added.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {restaurantsData.map((restaurant) => (
                <div
                  key={restaurant._id}
                  className="bg-white shadow-md rounded-lg p-6 flex flex-col justify-between"
                >
                  <div>
                    <h2 className="text-lg font-semibold text-gray-700">
                      {restaurant?.name}
                    </h2>
                    <p className="text-sm text-gray-500 mt-2">
                      <span className="font-medium text-gray-600">
                        Traffic:{" "}
                      </span>
                      {restaurant?.footTrafficEstimate}
                    </p>
                    <p className="text-sm text-gray-500 mt-2">
                      <span className="font-medium text-gray-600">
                        Location:{" "}
                      </span>
                      {restaurant?.location}
                    </p>
                    <p className="text-sm text-gray-500 mt-2">
                      <span className="font-medium text-gray-600">
                        Price Per Week:{" "}
                      </span>
                      {restaurant?.basePricePerWeek?.toLocaleString()} €
                    </p>
                    <p className="text-sm text-gray-500 mt-2">
                      <span className="font-medium text-gray-600">
                        Status:{" "}
                      </span>
                      <span
                        className={`font-medium ${
                          restaurant?.status === "Pending Approval"
                            ? "text-red-500"
                            : "text-green-500"
                        }`}
                      >
                        {restaurant?.status}
                      </span>
                    </p>
                  </div>
                  <div className="mt-4 flex justify-between space-x-3">
                    <Link
                      to={`/restaurants/details/${restaurant._id}`}
                      className="text-sm bg-blue-100 text-blue-700 py-2 px-2 rounded-md flex items-center hover:bg-blue-200"
                    >
                      View Details
                    </Link>
                    <Link
                      to={`/fixedLocations/edit/${restaurant._id}`}
                      className="text-sm bg-green-100 text-green-700 py-1 px-3 rounded-md flex items-center hover:bg-green-200"
                    >
                      <GoPencil className="mr-1" />
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(restaurant._id)}
                      className="text-sm bg-red-100 text-red-700 py-1 px-3 rounded-md flex items-center hover:bg-red-200"
                    >
                      <BsTrash3 className="mr-1" />
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </OwnerLayout>
  );
}

export default Restaurants;
